const CONTRAT_MAP = {
  "santé": "hasContratSante",
  "sante": "hasContratSante",
  "prévoyance": "hasContratPrevoyance",
  "prevoyance": "hasContratPrevoyance",
  "décès": "hasContratDeces",
  "deces": "hasContratDeces",
};

const REGIME_MAP = {
  "général": "SECURITE_SOCIALE",
  "general": "SECURITE_SOCIALE",
  "sécu": "SECURITE_SOCIALE",
  "secu": "SECURITE_SOCIALE",
  "sécurité sociale": "SECURITE_SOCIALE",
  "securite sociale": "SECURITE_SOCIALE",
  "alsace": "ALSACE_MOSELLE",
  "moselle": "ALSACE_MOSELLE",
  "alsace-moselle": "ALSACE_MOSELLE",
  "spécial": "REGIME_SPECIAL",
  "special": "REGIME_SPECIAL",
  "agricole": "REGIME_SALARIES_AGRICOLES",
  "indépendant": "SECURITE_SOCIALE_INDEPENDANTS",
  "independant": "SECURITE_SOCIALE_INDEPENDANTS",
  "tns": "SECURITE_SOCIALE_INDEPENDANTS",
};

const STATUT_MAP = {
  "adhérent": "adherent",
  "adherent": "adherent",
  "prospect": "prospect",
  "ancien": "ancien_adherent",
  "partenaire": "partenaire",
};

const parseLeadQuery = (text) => {
  if (!text || !text.trim()) return {};

  const lower = text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const original = text.toLowerCase();
  const filters = {};

  for (const [keyword, field] of Object.entries(CONTRAT_MAP)) {
    const normalizedKeyword = keyword.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    const withPattern = new RegExp(`(avec|ayant|qui ont|qui a|possedant|detenant)\\s+(un\\s+)?contrat\\s+(de\\s+)?${normalizedKeyword}`, "i");
    const withoutPattern = new RegExp(`(sans|pas de|aucun|n'ayant pas|qui n'ont pas|sans contrat)\\s+(de\\s+)?${normalizedKeyword}`, "i");
    const simpleWithout = new RegExp(`sans\\s+${normalizedKeyword}`, "i");
    const simpleWith = new RegExp(`avec\\s+${normalizedKeyword}`, "i");

    if (withoutPattern.test(lower) || simpleWithout.test(lower)) {
      filters[field] = false;
    } else if (withPattern.test(lower) || simpleWith.test(lower)) {
      filters[field] = true;
    }

    if (lower.includes(`contrat ${normalizedKeyword}`) || lower.includes(`contrat de ${normalizedKeyword}`)) {
      if (!filters.hasOwnProperty(field)) {
        filters[field] = true;
      }
    }
  }

  const cotisationPatterns = [
    /cotisation[s]?\s*(?:>|sup[ée]rieure?\s*[àa]?|plus\s*(?:de|que)?|au\s*dessus\s*(?:de)?)\s*(\d+)/i,
    /cotisation[s]?\s*(\d+)\s*€?\s*(?:et plus|minimum|min)/i,
    />\s*(\d+)\s*€?\s*(?:de\s+)?cotisation/i,
  ];

  for (const pattern of cotisationPatterns) {
    const match = lower.match(pattern);
    if (match) {
      filters.cotisationMin = parseInt(match[1], 10);
      break;
    }
  }

  if (!filters.cotisationMin) {
    const simpleMatch = lower.match(/cotisation\s*>\s*(\d+)/);
    if (simpleMatch) filters.cotisationMin = parseInt(simpleMatch[1], 10);
  }

  const deptPatterns = [
    /d[ée]partement\s*(\d{2,3})/i,
    /dept?\s*(\d{2,3})/i,
  ];

  for (const pattern of deptPatterns) {
    const match = lower.match(pattern);
    if (match) {
      filters.departement = match[1];
      break;
    }
  }

  for (const [keyword, value] of Object.entries(REGIME_MAP)) {
    const normalizedKeyword = keyword.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    if (lower.includes(`regime ${normalizedKeyword}`) || lower.includes(`régime ${normalizedKeyword}`) || lower.includes(normalizedKeyword)) {
      if (keyword.length > 3) {
        filters.regime = value;
        break;
      }
    }
  }

  for (const [keyword, value] of Object.entries(STATUT_MAP)) {
    const normalizedKeyword = keyword.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    if (lower.includes(normalizedKeyword)) {
      filters.statut = value;
      break;
    }
  }

  return filters;
};

export default parseLeadQuery;
